import {Component, OnInit, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {SendEmailService} from '../../shared/services/send-email.service';

@Component({
    selector: 'form-send-email-bulk',
    templateUrl: 'form-send-email-bulk.html'
})

export class FormSendEmailBulkComponent implements OnInit {

    @Input() emails: string[];

    constructor(private dataStorageService: DataStorageService,
                private sendEmailService: SendEmailService) {
    }

    sendEmailForm: FormGroup;

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.sendEmailForm = new FormGroup({
            'emails': new FormControl(this.emails),
            'subject': new FormControl(),
            'text_content': new FormControl()
        });
    }

    onUpdate() {
        const emailObj = {
            type: 7,
            email_to: 'info@ihanatour.com',
            email_bcc: this.emails,
            subject: this.sendEmailForm.value.subject,
            content: this.sendEmailForm.value.text_content
        };
        this.sendEmailService.initEmail(emailObj);
    }
}
